import { useBrand } from "@/brand";

const Logo = ({ compact = false }) => {
  const brand = useBrand();
  return (
    <span className="flex items-center gap-3" data-testid="logo">
      <span
        className={`${
          compact ? "w-8 h-8 rounded-lg" : "w-10 h-10 rounded-xl"
        } bg-gradient-to-br ${brand.logoGradient} p-0.5 shadow-md shadow-emerald-500/20 flex items-center justify-center shrink-0`}
      >
        <span
          className={`w-full h-full bg-[#0B132B] ${
            compact ? "rounded-md" : "rounded-[10px]"
          } flex items-center justify-center`}
        >
          <svg
            className={`${compact ? "w-4 h-4" : "w-5 h-5"} ${brand.boltColor}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M13 2L3 14h8l-1 8 11-13h-8l1-7z" fill="currentColor" fillOpacity="0.15" />
            <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          </svg>
        </span>
      </span>
      {!compact && (
        <span className="flex flex-col">
          <span className="text-xl font-black tracking-tight text-white leading-none">
            {brand.wordmarkTop}<span className={brand.boltColor}>{brand.wordmarkAccent}</span>
          </span>
          <span className="text-[10px] uppercase tracking-widest text-emerald-300 font-semibold mt-0.5">
            {brand.tagline}
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
